import { Link } from "react-router-dom";
import { allSoftware, formatDownloads, sortSoftware } from "@/utils/software";
import type { Software } from "@/utils/software";
import SectionHeader from "@/components/base/SectionHeader";
import RatingStars from "@/components/base/RatingStars";

interface Props {
  onDownload: (item: Software) => void;
}

const latest = sortSoftware(allSoftware, "latest").slice(0, 5);

export default function LatestSection({ onDownload }: Props) {
  return (
    <section>
      <SectionHeader
        icon="ri-time-line"
        title="最新发布"
        desc="近期上架或更新的黄金投资软件"
        moreTo="/softwares"
      />
      <div className="card-surface" data-product-shop>
        <ul className="flex flex-col divide-y divide-background-200">
          {latest.map((item) => (
            <li key={item.id} className="p-4">
              <div className="flex items-center gap-4">
                <Link
                  to={`/detail/${item.id}`}
                  className="relative block h-16 w-20 shrink-0 overflow-hidden rounded-md bg-secondary-900 sm:w-24"
                >
                  <img
                    src={item.cover}
                    alt={`${item.name}软件界面截图`}
                    title={`${item.name} 黄金投资软件`}
                    className="h-full w-full object-cover object-top"
                  />
                </Link>
                <div className="min-w-0 flex-1">
                  <div className="flex flex-wrap items-center gap-2">
                    <Link
                      to={`/detail/${item.id}`}
                      className="font-heading text-base font-bold text-foreground-900 transition-colors hover:text-primary-700"
                    >
                      {item.name}
                    </Link>
                    <span className="chip bg-accent-100 text-accent-800">新上架</span>
                  </div>
                  <p className="mt-1 line-clamp-1 text-sm text-foreground-600">{item.intro}</p>
                  <div className="mt-1.5 flex flex-wrap items-center gap-x-4 gap-y-1 text-xs text-foreground-500">
                    <span className="flex items-center gap-1">
                      <i className="ri-price-tag-3-line" />v{item.version}
                    </span>
                    <span className="flex items-center gap-1">
                      <i className="ri-download-2-line" />
                      {formatDownloads(item.downloads)}
                    </span>
                    <RatingStars rating={item.rating} />
                  </div>
                </div>
                <button
                  type="button"
                  onClick={() => onDownload(item)}
                  className="btn-primary hidden shrink-0 py-2 text-sm sm:inline-flex"
                >
                  <i className="ri-download-2-line" />下载
                </button>
              </div>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}